import React from "react";
import { Header } from "../components/common/Header";
import Footer from "../components/common/Footer";

// 1) Import a dedicated CSS file for the Home component
import "./Home.css";

export const Home = () => {
  return (
    <div className="home-container">
      <Header active={1} />

      <main className="hero-section">
        {/* Overlay */}
        <span className="hero-overlay"></span>

        {/* Hero content */}
        <div className="hero-content">
          <h1 className="hero-title">
            Välkommen till Kifo Bokförlag
          </h1>
          <p className="hero-subtitle">
            Bokförlaget som tillgängliggör den tidiga kyrkans rikedom
            på svenska för både barn och vuxna.
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
};
